import { Axios } from 'src/class/Axios.js';

const mixinCreated = {
  data() {
    return {
      associations: [],
      businesses: [],
      crops: [],
      croptypes: [],
      farms: [],
      rangeDate: [],
      ribbons: [],
      years: [],
      zones: [],
      users: [],
      usersAll: [],
      workers: [],
      workersAll: [],
    };
  },

  methods: {
    getEndPoints() {
      const axiosRequests = [];
      if (this.filterOfAssociation)
        axiosRequests.push(Axios.getMasters('businesses/associations'));
      if (this.filterOfBusinesses)
        axiosRequests.push(Axios.getMasters('businesses/normal'));
      if (this.filterOfZones) axiosRequests.push(Axios.getMasters('zones'));
      if (this.filterOfCropTypes)
        axiosRequests.push(Axios.getMasters('croptypes'));
      if (this.filterOfCrops)
        axiosRequests.push(Axios.getMasters('farms/crops'));
      if (this.filterOfFarms)
        axiosRequests.push(
          Axios.getMasters(
            `farms/farms/wt/${!this.onlyFarmsFruits ? `only` : `onlyfruit`}`
          )
        );
      axiosRequests.push(Axios.getMasters('calendars/getyearsbusiness'));

      if (this.filterOfRibbons)
        axiosRequests.push(Axios.getMasters('ribbons/only'));
      if (this.filterOfUsers)
        axiosRequests.push(
          Axios.getMasters(
            'users/indexfield'
          )
        );
      if (this.filterOfWorkers) {
        if (this.withWorkersTrashed)
          axiosRequests.push(
            Axios.getMasters(
              'works/workers/indexFieldWithTrashed'
            )
          )
        else
          axiosRequests.push(
            Axios.getMasters(
              'works/workers/indexField'
            )
          )
      }
      ;

      return axiosRequests;
    },

    runData(response) {
      const result = {};
      response.forEach((resp) => {
        const {
          config: { url },
          data,
        } = resp;

        switch (url) {
          case `auth/farms/farms/wt/${!this.onlyFarmsFruits ? `only` : `onlyfruit`
            }`:
            result.farms = data.data;
            break;

          case 'auth/calendars/getyearsbusiness':
            result.calendar = data;
            break;

          case 'auth/businesses/associations':
            result.associations = data.data;
            break;

          case 'auth/businesses/normal':
            result.businesses = data.data;
            break;

          case 'auth/zones':
            result.zones = data.data;
            break;

          case 'auth/croptypes':
            result.croptypes = data.data;
            break;

          case 'auth/farms/crops':
            result.crops = data.data;
            break;

          case 'auth/ribbons/only':
            result.ribbons = data.data;
            break;

          case 'auth/users/indexfield':
            result.users = data.data;
            break;

          case 'auth/works/workers/indexField':
            result.workers = data.data;
            break;

          case 'auth/works/workers/indexFieldWithTrashed':
            result.workers = data.data;
            break;
        }
      });

      this.associations = result.associations
        ? this.concatAll(result.associations)
        : [];
      this.businesses = result.businesses ? result.businesses : [];
      this.zones = result.zones ? result.zones : [];
      this.croptypes = result.croptypes ? this.concatAll(result.croptypes) : [];
      this.crops = result.crops ? result.crops : [];
      this.farms = result.farms ? result.farms : [];
      this.ribbons = result.ribbons ? result.ribbons : [];
      this.usersAll = result.users ? result.users : [];
      this.users = [];

      this.workersAll = result.workers ? result.workers : [];
      this.workers = [];

      if (this.filterOfTimeRange) {
        const yearsArray = Object.keys(result.calendar)
          .map((key) => [key, result.calendar[key]])
          .reverse();

        this.years = yearsArray.map((year) => {
          return { name: year[0], id: year[0], disabled: false, years: year };
        });
      }
    },
    /**
    * Filtra this.users (pintado) usando this.usersAll (maestro)
    * basado en this.model.businesses_ids (múltiple)
    */
    filterUsersByBusinesses() {
      // Solo aplica si el filtro de users existe
      if (!this.filterOfUsers) return;
      // businesses_ids puede venir [] o null
      const selected = Array.isArray(this.model.businesses_ids)
        ? this.model.businesses_ids
        : [];
      // Si no hay empresas seleccionadas => users vacío y limpia selección
      if (selected.length === 0) {
        this.users = [];
        this.$set(this.model, 'users_ids', []);
        return;
      }
      // Normaliza IDs por si vienen string "1" vs number 1
      const selectedSet = new Set(selected.map((x) => Number(x)));
      const base = Array.isArray(this.usersAll) ? this.usersAll : [];

      const filtered = base.filter((u) => {
        const biz = Array.isArray(u.business) ? u.business : [];
        return biz.some((b) => selectedSet.has(Number(b.id)));
      });
      this.users = filtered;
      // Limpia seleccionados que ya no estén disponibles
      const selectedUsers = Array.isArray(this.model.users_ids)
        ? this.model.users_ids
        : [];

      if (selectedUsers.length > 0) {
        const allowed = new Set(filtered.map((u) => Number(u.id)));
        const cleaned = selectedUsers
          .map((x) => Number(x))
          .filter((id) => allowed.has(id));

        this.$set(this.model, 'users_ids', cleaned);
      }
    },
    /**
  * Filtra this.workers (pintado) usando this.workersAll (maestro)
  * basado en this.model.farm_ids (múltiple)
  */
    filterWorkersByfarms() {
      if (!this.filterOfWorkers) return;
      const selected = Array.isArray(this.model.farm_ids) ? this.model.farm_ids : [];
      // tu lógica: si no hay fincas, no mostrar workers
      if (selected.length === 0) {
        this.workers = [];
        this.$set(this.model, 'workers_ids', []);
        return;
      }

      const selectedSet = new Set(selected.map((x) => Number(x)));
      const base = Array.isArray(this.workersAll) ? this.workersAll : [];
      const filtered = base.filter((w) => selectedSet.has(Number(w.farm_id)));
      this.workers = filtered;

      // limpia selección previa que ya no aplique
      const selectedWorkers = Array.isArray(this.model.workers_ids)
        ? this.model.workers_ids
        : [];

      if (selectedWorkers.length > 0) {
        const allowed = new Set(filtered.map((w) => Number(w.id)));
        const cleaned = selectedWorkers
          .map((x) => Number(x))
          .filter((id) => allowed.has(id));

        this.$set(this.model, 'workers_ids', cleaned);
      }
    }
  },

};

export default mixinCreated;
